/*@ngInject*/
const TextAreaController = function ($scope, $controller, formViewerConstant, formComponentUtil, xmlUtil) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        this.onInit();
        this.refreshPrintValue();
    };

    this.$onChanges = function () {
        this.onChanges();
    };

    this.handleChange = function () {
        this.fieldStructure.hasLocalChanges = true;
        formComponentUtil.setupFieldProperties(this.fieldStructure);

        this.refreshPrintValue();
    };

    this.refreshPrintValue = function () {
        if (this.fieldStructure.fieldModel && !_.isNil(this.fieldStructure.fieldModel.value)) {
            this.printValue = this.fieldStructure.fieldModel.value.replace(/\n/g, '<br>');
        }
    };

    this.getManualHeight = function () {
        const isPrintPreview = this.fieldStructure.parentForm.printPreview;
        const inputHeight = this.fieldStructure.layout.inputHeight;

        return isPrintPreview ? false : inputHeight;
    };


    this.getMaxChar = function (options) {
        const optionsObject = xmlUtil.parseString(options);
        return parseInt(optionsObject.maxChars) > 0 ? optionsObject.maxChars : null;
    };

    this.getRichText = function (options) {
        const optionsObject = xmlUtil.parseString(options);
        return optionsObject.richText;
    };

    this.optionsList = {
        height: 200,
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'italic', 'clear']],
            ['fontname', ['fontname']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link']]
        ],
        dialogsInBody: true,
        disableResizeEditor: true,
        disableLinkTarget: true,
        defaultLinkTargetNewWindow: true,
        disableDragAndDrop: true,
        fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Lato', 'Tahoma', 'Times New Roman', 'Verdana'],
    };
    this.getRichTextOptions = function() {
        this.optionsList.height = this.fieldStructure.layout.inputHeight - 35;
        return this.optionsList;
    }

};

angular.module('umFormViewer')
    .controller('textAreaController', TextAreaController);
